export default "__VITE_PUBLIC_ASSET__cece3a72__"